<template>
	<button id="launchIntercom" class="launch-intercom" disabled>
		<i class="icon icon-help-2"></i>
	</button>
</template>

<script>
export default {
	name: 'VueHelp'
};
</script>

<style lang="scss" scoped>
.launch-intercom {
	height: 100%;
	width: 100%;
	@include clear-btn-styles;
	font-size: 20px;
	background: var(--bg-0);
	color: var(--bg-0-fg-4);
	border-radius: 0;

	&.disabled,
	[disabled] {
		opacity: 0.38;
		pointer-events: none;
	}

	@include mq($from: md-l) {
		&:hover {
			background: var(--menu-list-bg-hover);
			color: var(--bg-2-fg-3);
		}
	}

	@include header-focus-styles;
}
</style>
